const Report = () =>
  import(/* webpackChunkName: "user-admins" */ '@/pages/user/admin/index.vue')
const Create = () =>
  import(/* webpackChunkName: "user-admins" */ '@/pages/user/admin/create.vue')
const Edit = () =>
  import(/* webpackChunkName: "user-admins" */ '@/pages/user/admin/edit.vue')
const Detail = () =>
  import(/* webpackChunkName: "user-admins" */ '@/pages/user/admin/detail.vue')

export default {
  path: 'admins',
  meta: {
    label: 'admins',
    auth: 'admin',
    sectionTitle: 'shared.admins'
  },
  component: {
    name: 'UserAdmins',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'UserAdminsReport',
      path: '',
      meta: {
        title: 'nav.adminsReport',
        auth: 'report'
      },
      component: Report
    },
    {
      name: 'UserCreateAdmins',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: Create
    },
    {
      name: 'UserEditAdmin',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: Edit,
      props: true
    },
    {
      name: 'UserAdminDetail',
      path: ':id',
      meta: {
        label: 'detail',
        auth: 'detail'
      },
      component: Detail,
      props: true
    }
  ]
}
